import Swal from "sweetalert2";

export default (function (ctx, inject) {
  inject('swal2', Swal);
});


//////////////////
// WEBPACK FOOTER
// ./src/plugins/sweetalert2.js
// module id = ./src/plugins/sweetalert2.js
// module chunks = 34